
import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { LoadingActionContext } from '@/contexts/layouts/LoadingActionContext';
import { LoadingContext } from '@/contexts/layouts/LoadingContext';
import { DefaultInstitutionCreateLink, DefaultParticipantCreateLink, DefaultTrialCreateLink, ILinkContext, LinkContext } from '@/contexts/layouts/LinkContext';


interface ILinkProviderProps { }

const LinkProvider: FC<PropsWithChildren<ILinkProviderProps>> = ({ 
    children 
}) => {
    const [trialLinkEnabled, setTrialLinkEnabled] = useState<ILinkContext['trialLinkEnabled']>(true);
    const [createTrialLink, setCreateTrialLink] = useState<ILinkContext['createTrialLink']>(() => DefaultTrialCreateLink);
    const [institutionLinkEnabled, setInstitutionLinkEnabled] = useState<ILinkContext['institutionLinkEnabled']>(true);
    const [createInstitutionLink, setCreateInstitutionLink] = useState<ILinkContext['createInstitutionLink']>(() => DefaultInstitutionCreateLink);
    const [participantLinkEnabled, setParticipantLinkEnabled] = useState<ILinkContext['participantLinkEnabled']>(true);
    const [createParticipantLink, setCreateParticipantLink] = useState<ILinkContext['createParticipantLink']>(() => DefaultParticipantCreateLink);

    const context = useMemo(() => {
        return {
            trialLinkEnabled , 
            setTrialLinkEnabled:  (enabled?: ILinkContext['trialLinkEnabled']) => {
                if (enabled === undefined) {
                    setTrialLinkEnabled(() => true);
                }
                else {
                    setTrialLinkEnabled(() => enabled);
                }
            },
            institutionLinkEnabled, 
            setInstitutionLinkEnabled:  (enabled?: ILinkContext['institutionLinkEnabled']) => {
                if (enabled === undefined) {
                    setInstitutionLinkEnabled(() => true);
                }
                else {
                    setInstitutionLinkEnabled(() => enabled);
                }
            },
            participantLinkEnabled, 
            setParticipantLinkEnabled:  (enabled?: ILinkContext['participantLinkEnabled']) => {
                if (enabled === undefined) {
                    setParticipantLinkEnabled(() => true);
                }
                else {
                    setParticipantLinkEnabled(() => enabled);
                }
            },

            createTrialLink: createTrialLink,
            setCreateTrialLink: (createLinkFn?: ILinkContext['createTrialLink']) => {
                if (!createLinkFn) {
                    setCreateTrialLink(() => DefaultTrialCreateLink);
                }
                else {
                    setCreateTrialLink(() => createLinkFn);
                }
            },

            createInstitutionLink: createInstitutionLink,
            setCreateInstitutionLink: (createLinkFn?: ILinkContext['createInstitutionLink']) => {
                if (!createLinkFn) {
                    setCreateInstitutionLink(() => DefaultInstitutionCreateLink);
                }
                else {
                    setCreateInstitutionLink(() => createLinkFn);
                }
            },

            createParticipantLink: createParticipantLink,
            setCreateParticipantLink: (createLinkFn?: ILinkContext['createParticipantLink']) => {
                if (!createLinkFn) {
                    setCreateParticipantLink(() => DefaultParticipantCreateLink);
                }
                else {
                    setCreateParticipantLink(() => createLinkFn);
                }
            }
        }
    }, [
        createTrialLink, 
        setCreateTrialLink,
        createInstitutionLink, 
        setCreateInstitutionLink, 
        createParticipantLink, 
        setCreateParticipantLink, 
        trialLinkEnabled, 
        setTrialLinkEnabled,
        institutionLinkEnabled, 
        setInstitutionLinkEnabled,
        participantLinkEnabled, 
        setParticipantLinkEnabled,
    ])

    return (
        <LinkContext.Provider value={context}>
            {children}
        </LinkContext.Provider>
    )
}

export default LinkProvider;